import React, { useState } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { Button, CircularProgress, Dialog } from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import UploadIcon from "@material-ui/icons/Publish";

const UploadButton = ({
    className,
    hotelId,
    setModalInheritActive,
    setNeedSavedBanned,
    setFromUploadPrices,
    toolbarIsOpen,
}) => {
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const handleLoadOn = () => {
        setOpen(true);
        setLoading(true);
    };

    const handleLoadOff = () => {
        setLoading(false);
        setOpen(false);
    };

    const upload = (files) => {
        const formData = new FormData();
        formData.append("hotel_id", hotelId);
        formData.append("file", files, files.name);

        let apiUrl = "/upload";

        if (
            import.meta.env?.VITE_API_NEW_PRICE_LOADER === "true" &&
            import.meta.env?.VITE_API_PRICE_LOADER_URL
        ) {
            apiUrl = import.meta.env.VITE_API_PRICE_LOADER_URL + "/upload";
            formData.append(
                "api_token",
                import.meta.env?.VITE_API_TOKEN_FOR_API,
            );
        }

        axios
            .post(apiUrl, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                if (import.meta.env.VITE_API_NEW_PRICE_LOADER === "true") {
                    if (response.data?.error) {
                        alert(response.data?.error);
                    } else {
                        setNeedSavedBanned(false);
                        alert(
                            `Цены загружаются, отслеживайте прогресс в статусе`,
                        );
                        // setModalInheritActive(true)
                    }
                } else {
                    const { error_code, error_text } = response.data;

                    if (error_code && error_text) {
                        alert(`Ошибка #${error_code}: ${error_text}`);
                    } else {
                        setNeedSavedBanned(false);
                        alert(`Цены успешно загружены!`);
                        setModalInheritActive(true);
                    }
                }
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => handleLoadOff());
    };

    const handleUpload = ({ target: { files } }) => {
        handleLoadOn();
        const selectedFile = files[0];
        setFromUploadPrices(true);
        axios.get("/manager/data/vector_turn_off");
        if (import.meta.env.VITE_API_NEW_PRICE_LOADER !== "true") {
            axios
                .get(`/manager/data/hotels/${hotelId}/saved_banned`)
                .then((response) => {
                    console.log("Стопы успешно сохранились");
                    upload(selectedFile);
                })
                .catch((err) => {
                    console.error(err);
                    const ignorErr = confirm(
                        "Стопы не сохранились, всё равно хотите загрузить цены?",
                    );
                    if (ignorErr) {
                        upload(selectedFile);
                    }
                });
        } else {
            upload(selectedFile);
        }
    };

    return (
        <span className={className}>
            <input
                hidden
                value=""
                type="file"
                id="price-manager"
                onChange={handleUpload}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            />
            <label htmlFor="price-manager">
                <Button
                    style={{
                        backgroundColor: green[500],
                        color: "white",
                    }}
                    component="span"
                    variant="contained"
                    title="Массовая загрузка цен из файла"
                >
                    <UploadIcon />
                </Button>
            </label>
            {loading && (
                <Dialog
                    open={open}
                    maxWidth="xs"
                    fullWidth
                    PaperProps={{
                        style: {
                            width: 200,
                            height: 200,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                        },
                    }}
                >
                    <CircularProgress />
                </Dialog>
            )}
        </span>
    );
};

UploadButton.propTypes = {
    hotelId: PropTypes.number.isRequired,
    className: PropTypes.string,
};

export default UploadButton;
